import { Clinic } from 'lib/documents/clinic';

export type UnlockPipelineType = 'clinic' | 'payment';
export interface UnlockPipeline {
  label: string;
  value: UnlockPipelineType;
  include: (args: { clinic: Clinic }) => boolean;
}

export const ASSESSMENT_UNLOCK_PIPELINES: UnlockPipeline[] = [
  {
    label: 'Activate assessment in clinic',
    value: 'clinic',
    include: clinic =>
      !!clinic.clinic.crx_settings.patientHome?.shouldShowClinicAdminText
  },
  {
    label: 'Activate assessment with in-app payment',
    value: 'payment',
    include: ({ clinic }: { clinic: Clinic }) =>
      clinic.paymentConfig.assessment.enabled
  }
];
